import RewardsTabs from './Components/RewardTab';
import { REWARD_TABS } from './utils';
const MyRewards = () => <RewardsTabs allowedTabs={[ REWARD_TABS['SELF'], REWARD_TABS['INFLUENCER']]} />;
export default MyRewards;
